import Layout from "../Layout/Layout";
import {makeStyles} from "@material-ui/core";
import ApplicationTree from "./ApplicationTree/ApplicationTree";
import TreeContainer from "./ApplicationTree/TreeContainer";
import {useSelector} from "react-redux";
import clsx from "clsx";
import ScreenDesigner from "./Designers/ScreenDesigner";
import SchemaDesigner from "./Designers/SchemaDesigner";
import ImportData from "./ApplicationTree/ImportData/ImportData";
import MenuDesigner from "../../MenuDesignerNew";
import ListDesigner from "../../ListDesigner";
import JsonScreen from "../../JsonScreen";
import {useHistory} from "react-router";

const useStyles = makeStyles((theme) => ({
    appBar: {
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        height: '98%',
        padding: 10,
        marginLeft: 41
    },
    appBarShift: {
        width: `calc(100% - ${300}px)`,
        marginLeft: 300,
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
    },
}))

const ApplicationDesigner = () => {
    const classes = useStyles();
    const selectedRecord = useSelector(state => state.applicationBuilder.selectedRecord);
    const isOpenedTreeDrawer = useSelector(state => state.applicationBuilder.isOpenedTreeDrawer)
    const history = useHistory();
    return (
        <Layout>
            <TreeContainer>
                <ApplicationTree/>
            </TreeContainer>
            <div className={clsx(classes.appBar, {[classes.appBarShift]: isOpenedTreeDrawer})}>
                {selectedRecord.type === 'entity' && (
                    <SchemaDesigner
                        match={{params: {id: selectedRecord.id}}}
                    />
                )}
                {selectedRecord.type === 'screen' && (
                    <ScreenDesigner
                        designerType={'screen'}
                        match={{params: {id: selectedRecord.id}}}
                    />
                )}
                {selectedRecord.type === 'menu' && (
                    <MenuDesigner
                        match={{params: {id: selectedRecord.id}}}
                    />
                )}
                {selectedRecord.type === 'list' && (
                    <ListDesigner
                        location={{}}
                        match={{params: {id: selectedRecord.id}}}
                    />
                )}
                {(selectedRecord.type === 'content' && selectedRecord.id) &&  (
                    <JsonScreen
                        match={{params: {name: selectedRecord.id+`DefaultList`}}}
                        history={history}
                        location={{
                            state: {
                                inParam: {}
                            }
                        }}
                    />
                )}
                <ImportData/>
            </div>
        </Layout>
    )
}
export default ApplicationDesigner